import { put, takeLatest, fork } from "redux-saga/effects";
import { fetchInsiderAnalysisCategories } from "./index";
import ApiClient from "../../../../api/ApiClient";

function* onFetchInsiderAnalysisCategories() {
  try {
    const { data } = yield ApiClient.get("app.stock.insiderAnalysisCategories");
    yield put(
      fetchInsiderAnalysisCategories.success(
        data.map(category => ({
          ...category,
          id: category.value
        }))
      )
    );
  } catch (e) {
    yield put(fetchInsiderAnalysisCategories.failure(e));
  }
}

function* watchInsiderAnalysisCategories() {
  yield takeLatest(
    fetchInsiderAnalysisCategories.TRIGGER,
    onFetchInsiderAnalysisCategories
  );
}

export default [fork(watchInsiderAnalysisCategories)];
